import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useUser } from "~/Context/userContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "react-axios";

import { postMessageBoardTopicSubjectEdit, postMessageBoardTopicMessageEdit } from "~/api/getMessageBoard";
import { validate } from "./TopicEditValidationRules";
import useTrackCommentForm from "../useTrackCommentForm";

import styled from "styled-components";

import "~/css/forms.less";

export const Wrapper = styled.section`
  margin: 10px 0 40px 0;
`;
export const TipsWrapper = styled.section`
  display: inline;
  float: right;
`;

const TopicEditForm = ({ topic, onComplete }) => {
  let history = useHistory();
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);

  const initialFormValues = {
    subject: topic.subject,
    message: topic.message,
  };

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const postTrackEdit = async () => {
    setLoading(true);

    const payloadSubject = {
      id: topic.id,
      subject: inputs.subject,
      chimdir_save: userState.user.dir,
    };
    const payloadMessage = {
      id: topic.id,
      comment: inputs.message,
      chimdir_save: userState.user.dir,
    };
    const doJobs = async () => {
      const resultA = await postMessageBoardTopicSubjectEdit(axios, payloadSubject);
      const resultB = await postMessageBoardTopicMessageEdit(axios, payloadMessage);
      return [resultA, resultB];
    };
    doJobs()
      .then((result) => {
        setLoading(false);
        onComplete();
      })
      .catch((e) => {
        console.log("e:", e);
        setLoading(false);
      });
  };

  const backButton = () => {
    // console.log("backButton:");
    history.push(`/message-board/topic/${topic.id}`);
  };

  const { inputs, handleInputChange, handleSubmit, insertLinkTag, insertImageTag, errors } = useTrackCommentForm(
    initialFormValues,
    postTrackEdit,
    validate
  );

  return (
    <Wrapper className="TrackEditWrapper">
      <Form className="totd-form topic-edit-form" noValidate onSubmit={(e) => handleSubmit(e)}>
        <Form.Group as={Row} className={errors.subject ? "error" : ""}>
          <Col md={1}>
            <Form.Label>Subject:</Form.Label>
          </Col>
          <Col md={6}>
            <Form.Control name="subject" onChange={handleInputChange} value={inputs.subject || ""} type="text" autoComplete="off" />
            {errors.subject && <span className="help error">{errors.subject}</span>}
          </Col>
        </Form.Group>
        <Form.Group controlId="message" className={errors.message ? "error" : ""}>
          <Form.Label>Message:</Form.Label>
          <Form.Control
            disabled={loading}
            name="message"
            onChange={handleInputChange}
            value={inputs.message.replace(/<br\s*\/?>/gm, "\n") || ""}
            as="textarea"
            rows="10"
          />
          {errors.message && <span className="help error">{errors.message}</span>}
        </Form.Group>

        <Button disabled={loading} variant="success" type="submit">
          Save
        </Button>
        <Button onClick={(e) => backButton(e)} disabled={loading} variant="cancel" type="cancel">
          Cancel
        </Button>
        <div style={{ float: "right" }} className="tips">
          HTML Help:&nbsp;
          <a href="javascript:;" onClick={() => insertLinkTag()}>
            Add link
          </a>
          &nbsp;&nbsp;
          <a href="javascript:;" onClick={() => insertImageTag()}>
            Add Image
          </a>
        </div>
      </Form>
    </Wrapper>
  );
};

export default TopicEditForm;
